@if (observableLocales$ | async; as placeholderLocales) {
<span>
  <!--iOS tooltip-->
  <button type="button" (click)="openTooltip()"
    role="tooltip"
    [hidden]="!iOS"
    [attr.aria-label]="(placeholderLocales | localebykey:localeKey:localeView)">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex" aria-hidden="true"></app-locale>
  </button>
  <!--non-iOS tooltip-->
  <button type="button" [matTooltipPosition]="tooltipPosition" matTooltip="{{placeholderLocales | localebykey:localeKey:localeView}}"
    role="tooltip"
    [hidden]="iOS" [matTooltipClass]="{'custom-tooltip': true}" 
    [attr.aria-label]="(placeholderLocales | localebykey:localeKey:localeView)">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex" aria-hidden="true"></app-locale>
  </button>
</span>
}